import { render, staticRenderFns } from "./LimitationOfAgentsAdded.vue?vue&type=template&id=52d8ab6f&scoped=true&"
import script from "./LimitationOfAgentsAdded.vue?vue&type=script&lang=js&"
export * from "./LimitationOfAgentsAdded.vue?vue&type=script&lang=js&"
import style0 from "./LimitationOfAgentsAdded.vue?vue&type=style&index=0&id=52d8ab6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d8ab6f",
  null
  
)

export default component.exports